// src/json/servicesOverview.json
export const servicesOverviewBuildingEnvelopeRenewals = {
    eyebrow: "COMPREHENSIVE EXTERIOR",
    titleHighlight: "RESTORATION & PROTECTION:",
    BsTextParagraphHighlight: "At HRD Painting & Restoration, we specialize in restoring, protecting, and enhancing the exterior of high-rise and commercial buildings. Our expertise spans concrete repairs, professional painting, waterproofing, sealant application, high-build coatings, flashings, and insulation, ensuring your building remains structurally sound, energy-efficient, and well-protected against the elements.",
    items: [
        {
            title: "Our Process & Expertise Concrete Repairs & Structural Restoration",
            description: "Over time, concrete surfaces can develop cracks, spalling, and deterioration due to weather exposure, moisture infiltration, and general wear. Our team assesses and repairs damaged façades, balconies, and structural components, reinforcing your building’s strength and longevity"
        },
        {
            title: "Sealant & Flashing Replacement",
            description: "Properly sealed joints and functional flashings are essential in preventing water leaks and air infiltration. We replace aged or failing sealants and install durable flashings to maintain the integrity of your building’s envelope, ensuring optimal weather resistance and energy efficiency"
        },
        {
            title: "Professional Painting & High-Build Coatings",
            description: "We apply premium-grade paints and high-build coatings designed to withstand UV exposure, moisture, and environmental pollutants. These coatings not only revitalize your building’s appearance but also act as a protective barrier against deterioration, reducing long-term maintenance costs"
        },
        {
            title: "Enhanced Insulation for Energy Efficiency",
            description: "A well-insulated building helps reduce heating and cooling costs while improving occupant comfort. We assess and upgrade insulation materials to enhance thermal performance, keeping your building efficient and environmentally friendly"
        },
        {
            title: "Advanced Waterproofing Solutions",
            description: "Moisture intrusion can lead to serious structural issues, including mold growth and material degradation. Our waterproofing solutions include membranes, elastomeric coatings, and sealers that create an effective barrier against water penetration, protecting both the interior and exterior of your building"
        }

    ],
    imageUrl: "/assets/imgs/services/1BuildingEnvelopeRenewals/servicesOverview/fondo.png",
    button: {
        text: "Request a Quote",
        url: "/quote"
    }
};  